<div *ngIf="isLoading" class="screen_loader animate__animated absolute inset-0 z-[35] grid place-content-center bg-[#fafafa] opacity-65 dark:bg-[#060818]">
  <img class="ml-[5px] h-auto w-20 flex-none" src="/assets/images/loader.svg" alt="" />
</div>

<div>
  <div>
    <div class="mb-5 flex overflow-y-auto whitespace-nowrap border-b border-[#ebedf2] font-semibold dark:border-[#191e3a]">
      <a
        href="javascript:;"
        class="flex gap-2 border-b border-transparent p-4 !outline-none hover:border-primary hover:text-primary"
        [ngClass]="{
          '!border-primary text-primary': activeTab.toLowerCase() === 'contract-details',
        }"
        (click)="setActiveTab('contract-details')"
      >
        <icon-user class="h-5 w-5" />
        {{ "contract_details" | translate }}
      </a>

      <a
        href="javascript:;"
        class="flex gap-2 border-b border-transparent p-4 !outline-none hover:border-primary hover:text-primary"
        [ngClass]="{
          '!border-primary text-primary': activeTab.toLowerCase() === 'bills',
        }"
        (click)="setActiveTab('bills')"
      >
        <icon-settings />
        {{ "bills_label" | translate }}
      </a>
      <a
        href="javascript:;"
        class="flex gap-2 border-b border-transparent p-4 !outline-none hover:border-primary hover:text-primary"
        [ngClass]="{
          '!border-primary text-primary': activeTab.toLowerCase() === 'tier managment',
        }"
        (click)="setActiveTab('tier managment')"
      >
        <icon-tier-managment class="h-5 w-5" />
        {{ "tier_management" | translate }}
      </a>

      <a
        href="javascript:;"
        class="flex gap-2 border-b border-transparent p-4 !outline-none hover:border-primary hover:text-primary"
        [ngClass]="{
          '!border-primary text-primary': activeTab.toLowerCase() === 'users',
        }"
        (click)="setActiveTab('users')"
      >
        <icon-users-group class="h-5 w-5" />
        {{ "customers_label" | translate }}
      </a>

      <a
        *appHasRole="[userRole.SuperAdmin]"
        href="javascript:;"
        class="flex gap-2 border-b border-transparent p-4 !outline-none hover:border-primary hover:text-primary"
        [ngClass]="{
          '!border-primary text-primary': activeTab.toLowerCase() === 'danger-zone',
        }"
        (click)="setActiveTab('danger-zone')"
      >
        <icon-phone />
        {{ "danger_zone" | translate }}
      </a>
    </div>
    <div>
      <div>
        <div *ngIf="activeTab.toLowerCase() === 'contract-details'">
          <app-contract-details [contractId]="paramId"></app-contract-details>
        </div>

        <div *ngIf="activeTab.toLowerCase() === 'tier managment'" class="switch">
          <app-tier-managment [packageId]="packageId"></app-tier-managment>
        </div>

        <div *ngIf="activeTab.toLowerCase() === 'bills'">
          <app-bills [contractId]="paramId"></app-bills>
        </div>

        <div *ngIf="activeTab.toLowerCase() === 'users' && apiKey">
          <app-contract-users-table [apiKey]="apiKey"></app-contract-users-table>
        </div>

        <div *ngIf="activeTab.toLowerCase() === 'danger-zone'" class="switch">
          <div *appHasRole="[userRole.SuperAdmin]" class="grid grid-cols-1 gap-5 md:grid-cols-3">
            <app-contract-db-import [contractId]="paramId"></app-contract-db-import>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
